class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      console.log("vikas0")
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      console.log("vikas1")
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);




// <!--##################### Cart Upsell Script  ##################### -->
// document.addEventListener("DOMContentLoaded", () => {
//   setInterval(() => {
//     const absoluteNode = document.querySelector(".cart-drawer-wraper-container");
//     const closeModelButton = document.querySelector(".variants_close_model");
//     const variantListWrapper = document.getElementById("variant-list-wrapper");
//     const productCache = {};

//     if (closeModelButton) {
//       closeModelButton.addEventListener("click", () => {
//         absoluteNode.style.opacity = "0";
//         absoluteNode.style.zIndex = "-1";
//       });
//     }

//     // Function to render variants
//     function renderVariants(data) {
//       const variants = data.variants;
//       const productTitle = data.title;
//       const productImg = data.images[0];
//       variantListWrapper.innerHTML = "";

//       variants.forEach((variant) => {
//         const isAvailable = variant.available;
//         const variantHTML = `
//           <div class="item-upsell" data-variant-id="${variant.id}" data-variant-title="${variant.title}">
//             <div class="product-main-content">
//               <div class="img">
//                 <img src="${productImg}" alt="${productTitle}">
//               </div>
//               <div class="details">
//                 <span class="sidecart-product-title">${productTitle}</span>
//                 <div class="variant-title">
//                   <span class="variant-title-element">${variant.title}</span>
//                 </div>
//               </div>
//             </div>
//             <div class="item-price">
//               <span>₹ ${(variant.price / 100).toLocaleString("en-IN")}</span>
//               <button 
//                 type="button"
//                 class="button add-to-cart-button variant-atc"
//                 data-variant-id="${variant.id}"
//                 ${!isAvailable ? "disabled style='opacity:0.5; cursor:not-allowed;'" : ""}
//               >
//                 <span class="add-to-cart-text">${isAvailable ? "Add to cart" : "Out of stock"}</span>
//                 <span class="add-to-cart-text--added" style="display:none;">✅ Added</span>
//               </button>
//             </div>
//           </div>
//         `;
//         variantListWrapper.insertAdjacentHTML("beforeend", variantHTML);
//       });
//     }

//     // Function to attach upsell buttons
//     function attachUpsellButtonListeners() {
//       const childNodes = document.querySelectorAll(".cart-upsell-wrapper");

//       childNodes.forEach((item) => {
//         const button = item.querySelector("button[type=submit]");
//         const productHandle = button?.getAttribute("variant_handle");
//         if (!button || !productHandle) return;

//         button.addEventListener("click", function () {
//           absoluteNode.style.opacity = "1";
//           absoluteNode.style.zIndex = "4";

//           if (productCache[productHandle]) {
//             renderVariants(productCache[productHandle]);
//           } else {
//             fetch(`/products/${productHandle}.js`)
//               .then((res) => res.json())
//               .then((data) => {
//                 productCache[productHandle] = data;
//                 renderVariants(data);
//               })
//               .catch((err) => {
//                 console.error("Error loading variants:", err);
//               });
//           }
//         });
//       });
//     }

//     // Attach initially
//     attachUpsellButtonListeners();

//     // Handle variant add-to-cart
//     variantListWrapper.addEventListener("click", function (e) {
//       if (e.target.closest(".variant-atc")) {
//         const btn = e.target.closest(".variant-atc");
//         const variantId = btn.getAttribute("data-variant-id");

//         if (btn.disabled) return;

//         btn.disabled = true;
//         btn.querySelector(".add-to-cart-text").textContent = "Adding...";

//         fetch("/cart/add.js", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ id: variantId, quantity: 1 }),
//         })
//           .then((res) => res.json())
//           .then(() => {
//             btn.querySelector(".add-to-cart-text").style.display = "none";
//             btn.querySelector(".add-to-cart-text--added").style.display = "inline";

//            setTimeout(function(){
//               // ✅ Close variant modal
//             absoluteNode.style.opacity = "0";
//             absoluteNode.style.zIndex = "-1";
//            }, 6000)

//             // ✅ Refresh cart drawer content
//             fetch('/cart?view=drawer')
//               .then(res => res.text())
//               .then(html => {
//                 const parser = new DOMParser();
//                 const doc = parser.parseFromString(html, 'text/html');
//                 const newCart = doc.querySelector('#CartDrawer');
//                 const oldCart = document.querySelector('#CartDrawer');
//                 if (newCart && oldCart) {
//                   oldCart.innerHTML = newCart.innerHTML;

//                   // ✅ Rebind upsell buttons after cart refresh
//                   attachUpsellButtonListeners();
//                 }

//                 // ✅ Optional: Open cart drawer again
//                 document.querySelector('cart-drawer')?.open();
//               });
//           })
//           .catch((err) => {
//             console.error("Add to cart failed:", err);
//             btn.disabled = false;
//             btn.querySelector(".add-to-cart-text").textContent = "Add to cart";
//           });
//       }
//     });
//   }, 3000);
// });
// <!--##################### Cart Upsell Script  ##################### -->